import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum AddressesFormErrorStatesEnum {
    UpdateAddressFailed = ErrorStateScheduleEnum.AddressesFormStatesStartIndex,
    CreateAddressFailed
}
